module.exports = __webpack_public_path__ + "static/media/doc.248dbda4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/doc.png
// module id = 506
// module chunks = 0